import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_RENT_INSTRUMENTS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_RENT_INSTRUMENT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_RENT_INSTRUMENT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_RENT_INSTRUMENT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_RENT_INSTRUMENT:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
